import { render, staticRenderFns } from "./falvzixun.vue?vue&type=template&id=323d8530&scoped=true"
import script from "./falvzixun.vue?vue&type=script&lang=js"
export * from "./falvzixun.vue?vue&type=script&lang=js"
import style0 from "./falvzixun.vue?vue&type=style&index=0&id=323d8530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323d8530",
  null
  
)

export default component.exports